import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Form,
  InlineLoading,
  ExpandableTile,
  TileAboveTheFoldContent,
  TileBelowTheFoldContent
} from 'carbon-components-react';
import { ArrowRight16, UserAdmin32 } from '@carbon/icons-react';
import { useFormik } from 'formik';

interface UpdateFormValues {
  updateMyDBYDContactEmail: boolean;
}

const UpdateDBYDContact: React.FC<Props> = ({
  onSubmit,
  isSetEmailLinking,
  isExternalUser,
  importRecentEnquiries,
  setImportRecentEnquiries,
  userFirstName,
  userLocateEmail,
  isImportingEnquiries
}) => {
  const { handleSubmit } = useFormik<UpdateFormValues>({
    enableReinitialize: true,
    initialValues: {
      updateMyDBYDContactEmail: true
    },
    onSubmit: (values: UpdateFormValues) => {
      onSubmit(values);
    }
  });

  const [show, setShow] = useState<boolean>(true);

  const handleTileClick = () => {
    setShow(!show);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className="form-fields-wrapper">
        <div className={`textinput-fields-wrapper padding step4`}>
          <div className="description-wrapper">
            <div className="avatar-container">
              <UserAdmin32 />
            </div>
            <div className="description-container">
              <div className="description1">
                <span>{userFirstName},</span> SmarterWX Locate now manages your
                enquiry responses. Your BYDA contact email was updated to{' '}
                <span>{userLocateEmail}</span>
              </div>
              <div className="description2">
                Did you know that some asset owners respond directly to your
                BYDA email? That’s why we update it, making all responses
                available in SmarterWX Locate.
              </div>
            </div>
          </div>

          {!isExternalUser && (
            <div id="updateDBYDEmailSection" className="form-fields">
              <ExpandableTile
                className="tile-custom-style"
                handleClick={() => handleTileClick()}
              >
                <TileAboveTheFoldContent>
                  <div className="checkbox-container">
                    <Checkbox
                      labelText="Yes, also import my recent enquiries (last 3 months)"
                      id="importRecentEnquiries"
                      onChange={(val: boolean) => setImportRecentEnquiries(val)}
                      checked={importRecentEnquiries}
                    />
                    <div style={show ? undefined : { color: 'white' }}>
                      Why is this a good idea?
                    </div>
                  </div>
                </TileAboveTheFoldContent>
                <TileBelowTheFoldContent>
                  <div className="divider"></div>
                  <div className="qa-section-container">
                    <div className="qa-section-title">
                      Get the most out of Locate by importing your recent dig
                      enquiries
                    </div>
                    <div className="qa-wrapper">
                      <div>We find your recent enquiries in BYDA</div>
                      <div>
                        Using your linked account, we fetch BYDA enquiries for
                        the last 90 days
                      </div>
                    </div>
                    <div className="qa-wrapper">
                      <div>We preload your enquiries in SmarterWX Locate</div>
                      <div>
                        Your recent enquiries are easily accessible on an
                        interactive search map
                      </div>
                    </div>
                    <div className="qa-wrapper">
                      <div>We collate responses from asset owners too!</div>
                      <div>
                        Every response email and attachment received is neatly
                        arranged for you
                      </div>
                    </div>
                  </div>
                </TileBelowTheFoldContent>
              </ExpandableTile>
            </div>
          )}
        </div>
      </div>
      <div id="formButtons" className="form-buttons-wrapper padding">
        <Button
          kind="secondary"
          type="submit"
          size={'md'}
          renderIcon={
            isSetEmailLinking || isImportingEnquiries ? '' : ArrowRight16
          }
          className="next-button"
          disabled={isSetEmailLinking || isImportingEnquiries}
        >
          {!(isSetEmailLinking || isImportingEnquiries) ? (
            'Continue'
          ) : (
            <InlineLoading
              description={
                !(isSetEmailLinking || isImportingEnquiries)
                  ? 'Continue'
                  : 'Submitting...'
              }
              status={
                !(isSetEmailLinking || isImportingEnquiries)
                  ? 'finished'
                  : 'active'
              }
              aria-live={'assertive'}
            />
          )}
        </Button>
      </div>
    </Form>
  );
};

type Props = {
  onSubmit: Function;
  isSetEmailLinking?: boolean;
  isExternalUser?: boolean;
  importRecentEnquiries: boolean;
  setImportRecentEnquiries: Function;
  userFirstName: string;
  userLocateEmail: string;
  isImportingEnquiries: boolean;
};

export default React.memo(UpdateDBYDContact);
